import { render, staticRenderFns } from "./BoardTemplatesList.vue?vue&type=template&id=235f07ea&scoped=true&"
import script from "./BoardTemplatesList.vue?vue&type=script&lang=ts&"
export * from "./BoardTemplatesList.vue?vue&type=script&lang=ts&"
import style0 from "./BoardTemplatesList.vue?vue&type=style&index=0&id=235f07ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "235f07ea",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VFadeTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
import { VItem } from 'vuetify/lib/components/VItemGroup';
import { VItemGroup } from 'vuetify/lib/components/VItemGroup';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VScrollYTransition } from 'vuetify/lib/components/transitions';
installComponents(component, {VCard,VCol,VDialog,VFadeTransition,VHover,VImg,VItem,VItemGroup,VOverlay,VRow,VScrollYTransition})
